import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SaveOrgAuthRequest, SaveWebkassaCashboxRequest, WebkassaResourceService } from 'hx-services';

@Injectable({providedIn: 'root'})
export class WebkassaCashboxService {
  constructor(
    private webkassaResource: WebkassaResourceService
  ) {
  }

  getCashboxList(params?: {
    query?: string,
    limit?: number,
    page?: number,
    sort?: string[],
    orgId?: number,
    includeDisabled?: boolean,
  }) {
    return firstValueFrom(this.webkassaResource.getWebkassaCashboxList(params?.includeDisabled, params?.limit, params?.orgId, params?.page, params?.query, params?.sort));
  }

  removeCashbox(id: number) {
    return firstValueFrom(this.webkassaResource.removeWebkassaCashboxById(id));
  }

  getCashboxById(id: number) {
    return firstValueFrom(this.webkassaResource.getWebkassaCashboxById(id));
  }

  saveCashbox(req: SaveWebkassaCashboxRequest) {
    return firstValueFrom(this.webkassaResource.saveWebkassaCashbox(req));
  }

  removeOrgAuth(id: number) {
    return firstValueFrom(this.webkassaResource.removeWebkassaOrgAuthById(id));
  }

  getOrgAuths(params?: {
    limit?: number,
    page?: number,
    sort?: string[],
    orgId?: number,
    includeDisabled?: boolean,
  }) {
    return firstValueFrom(this.webkassaResource.getWebkassaOrgAuths(params?.includeDisabled, params?.limit, params?.orgId, params?.page, params?.sort));
  }

  getOrgAuthById(id: number) {
    return firstValueFrom(this.webkassaResource.getWebkassaOrgAuthById(id));
  }

  saveOrgAuth(req: SaveOrgAuthRequest) {
    return firstValueFrom(this.webkassaResource.saveWebkassaOrgAuth(req));
  }
}
